import type { IconDefinition } from '../index.tsx';

export const iconSkipForward: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSkipForward',
  icon: [16, 16, [], '', 'M4 15H2V1H4L10 7V1H14V15H10V9L4 15Z'],
};
